import './HidePastWebinars.scss'

import AdminContext from 'lib/context/AdminContext'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

export default function HidePastWebinars() {
  const { hidePastWebinars, setHidePastWebinars } = useContext(AdminContext)
  const [t] = useTranslation()

  return (
    <label className="hide-past-webinars">
      {t('home.upcomingWebinarsSection.admin.hidePastWebinars.text')}
      <input type="checkbox" checked={hidePastWebinars} onChange={e => setHidePastWebinars(e.target.checked)} />
    </label>
  )
}
